import * as React from 'react';
import ReactTable from 'react-table';
import CustomPagination from '../../sys/pagination';
import { Button } from 'semantic-ui-react';
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { DataRequest, RefreshFunctionSignature } from '../../api';
import { default as Renderers } from '../../sys/columns';
const _ = require('lodash');
const FontAwesome = require('react-fontawesome');

class State {
}

interface Props {
    refresh ?: number;
}

export default class RvlStatusView extends React.Component<Props, State> {

    public static defaultProps: Partial<Props> = {
        refresh: 5000
    };

    protected columns = [{
        width: 15,
    }, {
        width: 30,
        accessor: 'streamid',
        Cell: (props: any) => this.buttonRenderer(props)
    }, {
        Header: 'Name',
        accessor: 'name',
        headerStyle: {textAlign: 'left'},
        width: 350,
        aggregate: (values: any, row: any) => (values.length > 0) ? {min: _.min(values), max: _.max(values)} : null,
        Cell: (props: any) => this.assetNameRenderer(props)
    }, {
        Header: 'Stream Status',
        accessor: 'streamStatus',
        headerStyle: {textAlign: 'left'},
        width: 160,
        aggregate: (values: any, row: any) => (values.length > 0) ? _.uniq(values) : null,
    }, {
        Header: 'RVL Status',
        accessor: 'rvlStatus',
        headerStyle: {textAlign: 'left'},
        width: 150,
        Aggregated: (row: any) => { return null; }
    }, {
        Header: 'Source Parameters',
        columns: [
            {
                Header: 'MAC Address',
                accessor: 'sourceMac',
                align: 'right',
                headerStyle: { textAlign: 'right' },
                width: 130,

            }, {
                Header: 'IP Address',
                accessor: 'sourceIp',
                align: 'right',
                headerStyle: { textAlign: 'right' },
                width: 130,

            }, {
                Header: 'UDP Port',
                accessor: 'sourcePort',
                align: 'right',
                headerStyle: { textAlign: 'right' },
                width: 130,

            }
        ]
    }, {
        Header: 'Destination Parameters',
        columns: [
            {
                Header: 'MAC Address',
                accessor: 'destMac',
                align: 'right',
                width: 190,
                headerStyle: { textAlign: 'right' },

            }, {
                Header: 'IP Address',
                accessor: 'destIp',
                align: 'right',
                width: 160,
                headerStyle: { textAlign: 'right' },
            }, {
                Header: 'UDP Port',
                accessor: 'destPort',
                align: 'right',
                width: 130,
                headerStyle: { textAlign: 'right' },
            }
        ]
    }, {
        Header: 'Transmit Packets',
        accessor: 'xmitCount',
        align: 'right',
        headerStyle: {textAlign: 'right'},
        width: 150,
        Aggregated: (row: any) => { return null; }
    }, {
        width: 20
    }];
    private dataRefresh: RefreshFunctionSignature;

    componentWillMount() {
        Renderers.ReactTable(this.columns);
    }

    render() {
        return (
            <div className="view-content" id="txlog">
                <DataRequest
                    auto                // automatically request on data change (filter change)
                    debounce={350}     // debounce multiple requests (i.e. as user types in filter box)
                    interval={this.props.refresh}     // update every 5 seconds
                    method="get"
                    endpoint="api/stream/control/rvl/status"
                >
                { (request: any) => {
                    const { stream, active, limit } = request.data && request.data.status || {
                        // default values shown until request is completed
                        stream: [],
                        active: undefined,
                        limit: undefined
                    };
                    return (<React.Fragment>
                        <div className="pageTitle displayFlex">
                            <div className="page-title-block">
                                <div className="iq-temp-key-val">
                                    <div className="iq-temp-val page-title-text">RVL Status</div>
                                </div>
                            </div>
                            <div className="iq-temp-key-val">
                                <div className="iq-temp-key">Active</div>
                                <div className="iq-temp-val"> {active}</div>
                            </div>
                            <div className="iq-temp-key-val">
                                <div className="iq-temp-key">Maximum</div>
                                <div className="iq-temp-val"> {limit}</div>
                            </div>
                        </div>
                        <div className="filterPanel">
                            <Button
                                className="filterPanel-right-primary-btn"
                                title="Start All Streams"
                                content="Start All"
                                onClick={() => this.manageAllStreams('start')}
                            />
                            <Button
                                className="filterPanel-secondary-btn"
                                title="Stop All Streams"
                                content="Stop All"
                                onClick={() => this.manageAllStreams('stop')}
                            />
                        </div>
                        <div className="view-clientarea">
                            <ReactTable
                                className="content-bg transaction-log -striped -highlight outside-scroll"
                                onFetchData={request.refresh}
                                data={stream}
                                columns={this.columns}
                                defaultPageSize={16}
                                PaginationComponent={CustomPagination}
                            />
                        </div>
                    </React.Fragment>
                ); }}
                </DataRequest>
            </div>
        );
    }

    assetNameRenderer(props: any): React.ReactNode  {
        const clsName = (props.original.rvlActive)
            ? 'iq-td-status-clear td-colored-cell'
            : '';
        return <div className={clsName} >{props.original.name}</div>;
    }

    buttonRenderer(props: any): React.ReactNode {
        let icon = 'pause-circle';
        let title = 'Stop Stream';
        if (!props.original.rvlActive) {
            icon = 'play-circle';
            title = 'Start Stream';
        }

        return (
            <div className="cellIcons" title={title}>
                <Button className="grid-hamburger-menu-button" onClick={(event) => this.manageStream(event, props)}>
                    <FontAwesome name={icon}/>
                </Button>
            </div>
        );
    }

    manageStream(event: any, props: any) {
        const cmd = (!props.original.rvlActive)
            ? 'start'
            : 'stop';

        let url = 'http://default/api/stream/' + props.original.streamid + '/control/rvl/' + cmd;
        axios.post(url)
            .then((response: AxiosResponse) => {
                if (response.data !== undefined && response.data.code === 'SUCCESS') {
                    // tslint:disable-next-line:no-unused-expression
                    this.dataRefresh && this.dataRefresh();
                } else
                    // tslint:disable-next-line:no-console
                    console.log('expected rvl success response', response.data);
            })
            .catch( (error: AxiosRequestConfig) => {
                // tslint:disable-next-line:no-console
                console.log('rvlStreamOp error: ', error);
            });
    }

    manageAllStreams(cmd: string) {
        let url = 'http://default/api/stream/control/rvl/' + cmd;
        axios.post(url)
            .then((response: AxiosResponse) => {
                if (response.data !== undefined && response.data.code === 'SUCCESS') {
                    // tslint:disable-next-line:no-unused-expression
                    this.dataRefresh && this.dataRefresh();
                } else
                    // tslint:disable-next-line:no-console
                    console.log('expected rvl success response', response.data);
            })
            .catch( (error: AxiosRequestConfig) => {
                // tslint:disable-next-line:no-console
                console.log('rvlStreamOp error: ', error);
            });
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/monitoring/rvlStatus.tsx